const scrollToError = (): void => {
  const errorElement = document.querySelector('.Typography_color_error, .ErrorMessage')

  if (errorElement) {
    errorElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
  }
}

export { scrollToError }
